module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point01_05_travel-1e83e0fcab5c97b8f77c8f7bb850698a.jpg";